import React from "react";
import {SiteData} from "../../Constants/siteData";
import {PageWrapper} from "../../Components/PageWrapper/PageWrapper";
import PageHeader from "../../Components/common/PageHeader";
import ServicePageTemplate from "../../Containers/ServiceContainers/ServicePageTemplate";
import {SEO} from "../../Components/SEO/SEO";

export default function ArboristConsultation() {
    return (
        <PageWrapper>
            <SEO title={SiteData.arboristConsulting.metaData.title} description={SiteData.arboristConsulting.metaData.description}/>
            <PageHeader header={SiteData.arboristConsulting.h1} subtitle={SiteData.arboristConsulting.subtitle}/>
            <ServicePageTemplate body={SiteData.arboristConsulting.body}/>
        </PageWrapper>
    )
}
